// i18n area 'hci' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.el-GR.meta.json.
import type { enUS } from './hci'

export const elGR: typeof enUS = {
  hci: {
    ceph: {
      title: 'Συστοιχίες Ceph',
      createButton: 'Δημιουργία συστοιχίας Ceph',
      emptyTitle: 'Καμία διαχειριζόμενη συστοιχία Ceph ακόμη',
      emptyBody: 'Το TVirt αναπτύσσει και κατέχει το Ceph στους κόμβους-μέλη, σε υπερσύγκλιση με το φορτίο των VM. Δημιουργήστε μια συστοιχία: ο πρώτος monitor και ο manager του γεννιούνται αυτόματα στον επιλεγμένο κόμβο ελέγχου — μετά μεγαλώστε την με περισσότερους monitor και συσκευές OSD.',
      pageTitle: 'Συστοιχίες Ceph',
      colState: 'Κατάσταση',
      colMembers: 'Μέλη',
      colSize: 'Μέγεθος',
      colVersion: 'Έκδοση Ceph',
      sizeCell: '{used} GiB σε χρήση από {total} GiB συνολικά',
      phase: {
        'not-deployed': 'Μη αναπτυγμένη',
        deploying: 'Ανάπτυξη σε εξέλιξη',
        healthy: 'Υγιής',
        degraded: 'Υποβαθμισμένη',
        error: 'Σφάλμα',
        destroying: 'Σε καταστροφή',
        destroyed: 'Κατεστραμμένη'
      },
      health: {
        HEALTH_OK: 'Υγιής (HEALTH_OK)',
        HEALTH_WARN: 'Με προειδοποιήσεις (HEALTH_WARN)',
        HEALTH_ERR: 'Σε σφάλμα (HEALTH_ERR)',
        unknown: 'Δεν έχει παρατηρηθεί ακόμη',
        observedAt: 'παρατηρήθηκε {time}'
      },
      create: {
        title: 'Δημιουργία συστοιχίας Ceph',
        info: 'Κατά τη δημιουργία μιας νέας συστοιχίας Ceph επιλέγεται ο πρώτος κόμβος στον οποίο θα εγκατασταθούν οι ρόλοι MON και MGR. Πρέπει επίσης να καθοριστεί ποιο subnet θα χρησιμοποιηθεί για την κίνηση του Ceph: το public subnet χρησιμοποιείται για τη γενική κίνηση δικτύου, ενώ το cluster subnet χρησιμοποιείται για τα εσωτερικά αντίγραφα μεταξύ των OSD· δεν απαιτούνται απαραίτητα διαφορετικά subnet.',
        controlNode: 'Κόμβος ελέγχου',
        controlNodeHint: 'Ο κόμβος-μέλος όπου γεννιούνται ο πρώτος MON + MGR.',
        publicSubnet: 'Public subnet',
        publicSubnetHint: 'Ένα Subnet καταχωρισμένο στο IPAM — το public_network του Ceph. Αμετάβλητο μετά τη δημιουργία.',
        clusterSubnet: 'Cluster subnet',
        clusterSubnetHint: 'Ένα Subnet καταχωρισμένο στο IPAM — το cluster_network του Ceph (αντιγραφή/backfill).',
        noSubnets: 'Κανένα Subnet καταχωρισμένο — δημιουργήστε τα πρώτα στο IPAM',
        sameSubnet: 'Ίδιο subnet για την κίνηση public και cluster',
        sameSubnetHint: 'Επιλεγμένο = το δίκτυο cluster (αντιγραφή/backfill) συμπίπτει με το public. Μη επιλεγμένο = επιλέξτε το δικό του subnet ΚΑΙ τη διεύθυνση του κόμβου ελέγχου μέσα σε αυτό.',
        controlAddress: 'Διεύθυνση του κόμβου ελέγχου',
        controlAddressHint: 'Μια διεύθυνση που γνωρίζει το IPAM για τον κόμβο μέσα στο public subnet.',
        controlClusterAddress: 'Διεύθυνση cluster του κόμβου ελέγχου',
        controlClusterAddressHint: 'Μια διεύθυνση που γνωρίζει το IPAM για τον κόμβο μέσα στο cluster subnet.',
        noAddresses: 'Το IPAM δεν γνωρίζει διευθύνσεις αυτού του κόμβου μέσα στο επιλεγμένο subnet',
        started: 'Η συστοιχία δημιουργήθηκε — το bootstrap συνεχίζεται ως μακροεργασία· η φάση ενημερώνεται μόνη της',
        error: 'Η συστοιχία απορρίφθηκε'
      },
      detail: {
        actions: 'Διαθέσιμες ενέργειες',
        tabOverview: 'Επισκόπηση',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pool',
        tabObjects: 'Αντικείμενα',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Για προχωρημένους',
        phase: 'Φάση',
        checksTitle: 'Ενεργά check υγείας',
        noChecks: 'Κανένα ενεργό check υγείας',
        checkMuted: 'σε σίγαση',
        summaryPools: 'Pool',
        summaryFilesystems: 'Συστήματα αρχείων',
        nodesCard: 'Κόμβοι',
        monHint: 'Ένας MGR τρέχει συστεγασμένος με κάθε MON. Τρεις MON είναι η συνιστώμενη απαρτία· μια εργαστηριακή συστοιχία ξεκινά με έναν. Οι OSD και οι MDS ζουν στις δικές τους καρτέλες.',
        monHintSplit: 'Οι MON και οι MGR είναι διαχωρισμένοι σε αυτή τη συστοιχία (Για προχωρημένους): κάθε ρόλος είναι δική του membership ανά κόμβο. Τρεις MON είναι η συνιστώμενη απαρτία· τουλάχιστον ένας MGR πρέπει να υπάρχει.',
        noMons: 'Κανένας monitor δηλωμένος',
        addNode: 'Προσθήκη κόμβου',
        removeNode: 'Αφαίρεση κόμβου',
        removeNodeFrom: 'Αφαίρεση του κόμβου {node} (ο MON του και ο συστεγασμένος MGR)',
        roleMon: 'Ρόλος MON',
        roleMgr: 'Ρόλος MGR',
        roleNa: 'N/A',
        roleNotObserved: 'δεν έχει παρατηρηθεί ακόμη',
        monInQuorum: 'σε απαρτία',
        monOutQuorum: 'εκτός απαρτίας',
        mgrActive: 'active',
        mgrStandby: 'standby',
        addRoleMon: 'Προσθήκη ρόλου MON',
        removeRoleMon: 'Αφαίρεση ρόλου MON',
        addRoleMgr: 'Προσθήκη ρόλου MGR',
        removeRoleMgr: 'Αφαίρεση ρόλου MGR',
        restartMon: 'Επανεκκίνηση υπηρεσίας MON',
        restartMgr: 'Επανεκκίνηση υπηρεσίας MGR',
        addMon: 'Προσθήκη MON',
        removeMon: 'Αφαίρεση MON',
        removeMonFrom: 'Αφαίρεση του ρόλου MON από τον κόμβο {node}',
        addMgr: 'Προσθήκη MGR',
        removeMgr: 'Αφαίρεση MGR',
        removeMgrFrom: 'Αφαίρεση του ρόλου MGR από τον κόμβο {node}',
        addMds: 'Προσθήκη MDS',
        removeMds: 'Αφαίρεση MDS',
        removeMdsFrom: 'Αφαίρεση του ρόλου MDS από τον κόμβο {node}',
        mdsSection: 'Metadata server (MDS)',
        noMds: 'Κανένας MDS δηλωμένος — ένα σύστημα αρχείων χρειάζεται πρώτα έναν',
        mdsHint: 'Η membership των MDS είναι δική της από την πρώτη μέρα: μια συστοιχία χωρίς CephFS δεν δηλώνει κανέναν, ένας active συν ένας standby εξυπηρετούν καλά ένα σύστημα αρχείων. Το Ceph εκλέγει τους active και τους standby ανάμεσα στους δηλωμένους δαίμονες.',
        mdsActiveFor: 'active — {fs}',
        mdsNotObserved: 'δεν έχει παρατηρηθεί ακόμη',
        lastMdsGuard: 'Ο τελευταίος MDS δεν μπορεί να αφαιρεθεί όσο υπάρχει σύστημα αρχείων — αφαιρέστε πρώτα τα συστήματα αρχείων',
        lastMonGuard: 'Ο τελευταίος MON δεν μπορεί να αφαιρεθεί — η καταστροφή της συστοιχίας είναι η μόνη διέξοδος',
        lastMgrGuard: 'Ο τελευταίος MGR δεν μπορεί να αφαιρεθεί — μια διαχειριζόμενη συστοιχία δεν τρέχει ποτέ χωρίς manager',
        registerDevice: 'Προσθήκη OSD',
        unregisterDevice: 'Κατάργηση καταχώρισης',
        activeDeviceGuard: 'Ενεργός OSD — φεύγει μέσα από τον κύκλο ζωής OSD, όχι από το μητρώο',
        colNode: 'Κόμβος',
        devicePhase: { registered: 'Καταχωρισμένη', active: 'Ενεργή' },
        health: 'Υγεία',
        state: 'Κατάσταση',
        fsid: 'fsid',
        fsidPending: 'απουσιάζει — ξαναδοκιμάστε το bootstrap',
        version: 'Έκδοση Ceph',
        publicNetwork: 'Δίκτυο public',
        clusterNetwork: 'Δίκτυο cluster',
        clusterNetworkCollapsed: '= public',
        noActions: 'Καμία ενέργεια διαθέσιμη σε αυτή τη φάση',
        destroyedNote: 'Η συστοιχία καταστράφηκε — η γραμμή αφαιρείται αυτόματα σε λίγο'
      },
      overview: {
        services: 'Υπηρεσίες',
        ok: 'υγιείς',
        warning: 'warning',
        down: 'down',
        pgTitle: 'Καταστάσεις των PG',
        pgTotal: '{n} PG συνολικά',
        capacityTitle: 'Χωρητικότητα',
        ioTitle: 'Τρέχον I/O',
        ioReadBw: 'Εύρος ζώνης ανάγνωσης',
        ioWriteBw: 'Εύρος ζώνης εγγραφής',
        ioReadIops: 'IOPS ανάγνωσης',
        ioWriteIops: 'IOPS εγγραφής',
        notObserved: 'δεν έχει παρατηρηθεί ακόμη'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Κατάσταση',
        colSize: 'Μέγεθος',
        colPgs: 'PG',
        empty: 'Κανένας OSD — προσθέστε έναν από δηλωμένο δίσκο δεδομένων',
        markIn: 'Επισήμανση IN',
        markOut: 'Επισήμανση OUT',
        scrub: 'Εκτέλεση scrub',
        deepScrub: 'Εκτέλεση βαθιού scrub',
        restart: 'Επανεκκίνηση υπηρεσίας',
        details: 'Λεπτομέρειες',
        actionGuard: 'Μόνο σε ενεργό OSD αναπτυγμένης συστοιχίας',
        inTitle: 'Επισήμανση OSD IN',
        inBody: 'Ο osd.{id} επιστρέφει στην κατανομή των δεδομένων (ceph osd in): το Ceph επανεξισορροπεί τα δεδομένα πάνω του.',
        outTitle: 'Επισήμανση OSD OUT',
        outBody: 'Ο osd.{id} βγαίνει από την κατανομή των δεδομένων (ceph osd out): τα δεδομένα του επανεξισορροπούνται αλλού και ο πλεονασμός είναι ΜΕΙΩΜΕΝΟΣ όσο τρέχει το backfill. Αναστρέψιμο ανά πάσα στιγμή με την Επισήμανση IN.',
        scrubTitle: 'Προγραμματισμός scrub',
        scrubBody: 'Προγραμματίζεται ένα scrub του osd.{id}: ο MON το βάζει στην ουρά και οι καταστάσεις των PG στις επόμενες σαρώσεις αφηγούνται την έκβαση.',
        deepScrubTitle: 'Προγραμματισμός βαθιού scrub',
        deepScrubBody: 'Προγραμματίζεται ένα βαθύ scrub του osd.{id}: η παραλλαγή που επαληθεύει τα byte — βαρύτερη στο I/O, ίδια μηχανική.',
        restartTitle: 'Επανεκκίνηση υπηρεσίας OSD',
        restartBody: 'Ο osd.{id} σταματά και επανεκκινείται μέσα από την εποπτεία του worker στον κόμβο του.',
        started: 'Η ενέργεια ξεκίνησε — η παρατήρηση ενημερώνεται μόνη της',
        error: 'Η ενέργεια OSD απορρίφθηκε'
      },
      osdDetail: {
        title: 'Λεπτομέρειες OSD',
        tabGeneral: 'Γενικά',
        tabNetwork: 'Δίκτυο',
        tabDevices: 'Συσκευές',
        version: 'Έκδοση',
        hostname: 'Hostname',
        dataPath: 'Διαδρομή δεδομένων OSD',
        objectStore: 'Object store OSD',
        encrypted: 'Κρυπτογραφημένος',
        yes: 'Ναι',
        no: 'Όχι',
        memory: 'Χρήση μνήμης (PSS)',
        pid: 'Process ID (PID)',
        front: 'Διεύθυνση front (client & monitor)',
        hbFront: 'Διεύθυνση heartbeat front',
        back: 'Διεύθυνση back (OSD)',
        hbBack: 'Διεύθυνση heartbeat back',
        colDevice: 'Device',
        colType: 'Τύπος',
        colPhysical: 'Φυσικό device',
        colSize: 'Μέγεθος',
        volumeTitle: 'Λεπτομέρειες τόμου',
        creationTime: 'Ημερομηνία δημιουργίας',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Κανένα device δεν παρατηρήθηκε για αυτόν τον OSD'
      },
      restart: {
        title: 'Επανεκκίνηση υπηρεσίας',
        monBody: 'Ο δαίμονας MON στον κόμβο {node} σταματά και επανεκκινείται μέσα από την εποπτεία του worker.',
        mgrBody: 'Ο δαίμονας MGR στον κόμβο {node} σταματά και επανεκκινείται μέσα από την εποπτεία του worker.',
        started: 'Η επανεκκίνηση ξεκίνησε — η παρατήρηση ενημερώνεται μόνη της',
        error: 'Η επανεκκίνηση απορρίφθηκε'
      },
      encryptionMode: {
        alwaysOn: 'Πάντα ενεργοποιημένη (dmcrypt)',
        alwaysOff: 'Πάντα απενεργοποιημένη',
        perOsd: 'Επιλογή ανά OSD',
        section: 'Κρυπτογράφηση OSD at rest',
        title: 'Αλλαγή λειτουργίας κρυπτογράφησης OSD',
        hint: 'Πώς προετοιμάζονται οι ΝΕΟΙ OSD. Οι υπάρχοντες OSD κρατούν την ανά δίσκο κατάστασή τους: για να αλλάξει ένας, αφαιρείται και ξαναδημιουργείται ο OSD.',
        body: 'Η λειτουργία γίνεται «{mode}» και ισχύει ΜΟΝΟ για τους ΝΕΟΥΣ OSD: κάθε υπάρχων OSD κρατά την τρέχουσα κατάσταση κρυπτογράφησής του.',
        apply: 'Αλλαγή λειτουργίας',
        error: 'Η αλλαγή λειτουργίας απορρίφθηκε'
      },
      pin: {
        address: 'Διεύθυνση public (προαιρετικό pin)',
        clusterAddress: 'Διεύθυνση cluster (προαιρετικό pin)',
        autoPlaceholder: 'αυτόματα μέσα στο subnet {cidr}',
        hint: 'Διευθυνσιοδότηση ανά δαίμονα: κενό = το Ceph δένεται μόνο του μέσα στο δηλωμένο δίκτυο· ορισμένο = αυτή η παρουσία του δαίμονα καρφιτσώνεται στη διεύθυνση στη δική της ενότητα conf.'
      },
      addMon: {
        title: 'Προσθήκη κόμβου',
        node: 'Κόμβος',
        address: 'Διεύθυνση public',
        addressHint: 'Οι διευθύνσεις του κόμβου που γνωρίζει το IPAM μέσα στο public subnet — αυτόματα όταν μια υπάρχουσα δήλωση καλύπτει τον κόμβο.',
        clusterAddress: 'Διεύθυνση cluster',
        clusterAddressHint: 'Υποχρεωτική: το cluster subnet είναι χωριστό και ο κόμβος δεν έχει δηλωθεί ακόμη σε αυτό.',
        noAddresses: 'Το IPAM δεν γνωρίζει διευθύνσεις αυτού του κόμβου μέσα στο subnet',
        error: 'Η προσθήκη του MON απορρίφθηκε'
      },
      removeMon: {
        title: 'Αφαίρεση MON',
        body: 'Ο MON και ο συστεγασμένος MGR του εγκαταλείπουν τον κόμβο {node}. Σε αναπτυγμένη συστοιχία οι δαίμονες σταματούν και αφαιρούνται από την απαρτία.',
        error: 'Η αφαίρεση του MON απορρίφθηκε'
      },
      addMgr: {
        title: 'Προσθήκη MGR',
        node: 'Κόμβος',
        hint: 'Για προχωρημένους (διαχωρισμένοι MON/MGR): ένας αυτόνομος manager γεννιέται στον επιλεγμένο κόμβο-μέλος με μια εργασία συναφή με τον κόμβο. Η εκλογή active/standby του Ceph επιλέγει μόνη της τον active MGR.',
        error: 'Η προσθήκη του MGR απορρίφθηκε'
      },
      removeMgr: {
        title: 'Αφαίρεση MGR',
        body: 'Ο αυτόνομος MGR εγκαταλείπει τον κόμβο {node}. Σε αναπτυγμένη συστοιχία ο δαίμονας σταματά και η κατάστασή του αφαιρείται· ο MON του κόμβου (αν υπάρχει) δεν θίγεται.',
        error: 'Η αφαίρεση του MGR απορρίφθηκε'
      },
      addMds: {
        title: 'Προσθήκη MDS',
        node: 'Κόμβος',
        hint: 'Ο metadata server του CephFS: γεννιέται στον επιλεγμένο κόμβο-μέλος με μια εργασία συναφή με τον κόμβο, υπό την εποπτεία του worker όπως οι MON και οι MGR. Το Ceph εκλέγει μόνο του τους active και τους standby — ένας active συν ένας standby εξυπηρετούν καλά ένα σύστημα αρχείων.',
        error: 'Η προσθήκη του MDS απορρίφθηκε'
      },
      removeMds: {
        title: 'Αφαίρεση MDS',
        body: 'Ο MDS εγκαταλείπει τον κόμβο {node}. Σε αναπτυγμένη συστοιχία ο δαίμονας σταματά και η κατάστασή του αφαιρείται· το API απορρίπτει τον τελευταίο MDS όσο ένα σύστημα αρχείων τον χρειάζεται.',
        error: 'Η αφαίρεση του MDS απορρίφθηκε'
      },
      split: {
        title: 'Διαχωρισμένοι MON/MGR',
        label: 'Να επιτρέπονται MON και MGR σε διαχωρισμένους κόμβους',
        hint: 'Ανενεργό (προεπιλογή) = το επικυρωμένο πρότυπο: ένας MGR τρέχει συστεγασμένος με κάθε MON, μία μόνο membership. Ενεργό = η membership των MGR γίνεται δική της, διαχειριζόμενη με τις ενέργειες Προσθήκη/Αφαίρεση MGR στην καρτέλα των κόμβων διαχείρισης.',
        enable: 'Ενεργοποίηση',
        disable: 'Απενεργοποίηση',
        enableBody: 'Η membership των MGR γίνεται ανεξάρτητη από τους MON, αρχικοποιημένη από την τρέχουσα συστέγαση. Οι ενέργειες Προσθήκη/Αφαίρεση MGR οπλίζονται στην καρτέλα των κόμβων διαχείρισης. Αυτό χαλαρώνει την προεπιλογή της πλατφόρμας — κρατήστε το μόνο αν ξέρετε γιατί το χρειάζεστε.',
        disableBody: 'Επιστροφή στην τυπική συστέγαση: ένας MGR με κάθε MON, μία μόνο membership. Νόμιμο μόνο όσο η membership των MGR συμπίπτει ήδη με τους MON — ευθυγραμμίστε την πρώτα με Προσθήκη/Αφαίρεση MGR, αλλιώς το API θα αρνηθεί.',
        error: 'Η τροποποίηση απορρίφθηκε'
      },
      rawEditor: {
        title: 'Ακατέργαστος editor CRUSH',
        label: 'Εμφάνιση του ακατέργαστου editor της crushmap στην καρτέλα CRUSH',
        hint: 'Ανενεργό (προεπιλογή) = η καθοδηγούμενη επιφάνεια των κανόνων είναι το τυπικό εργαλείο. Ενεργό = η καρτέλα CRUSH εμφανίζει και την απομεταγλωττισμένη crushmap ως επεξεργάσιμο κείμενο. Η αποθήκευση απαιτεί πάντα sudo, το όνομα της συστοιχίας ως επιβεβαίωση, και περνά από compile + test του crushtool ΠΡΙΝ φτάσει στη συστοιχία.'
      },
      osdFlags: {
        section: 'Καθολικές σημαίες OSD',
        title: 'Παράκαμψη σημαιών OSD',
        notObserved: 'δεν έχουν παρατηρηθεί ακόμη',
        standardFlowsHint: 'Οι τυπικές ροές της πλατφόρμας διαχειρίζονται αυτές τις σημαίες μόνες τους στις συνηθισμένες περιπτώσεις (η συντήρηση ενός κόμβου ορίζει ένα στοχευμένο noout, η αντικατάσταση δίσκου περνά από τον κύκλο ζωής OSD). Αυτή η ενότητα είναι η χειροκίνητη παράκαμψη για τον χειριστή που ξέρει τι κάνει.',
        notDeployedGuard: 'Οι σημαίες OSD υπάρχουν μόνο σε αναπτυγμένη συστοιχία',
        set: 'Ορισμός σημαίας',
        unset: 'Αφαίρεση σημαίας',
        setBody: 'Η καθολική σημαία {flag} θα ΟΡΙΣΤΕΙ στο osdmap. Μένει μέχρι να αφαιρεθεί ρητά — μια ξεχασμένη σημαία υποβαθμίζει την αυτόματη επιδιόρθωση της συστοιχίας.',
        unsetBody: 'Η καθολική σημαία {flag} θα ΑΦΑΙΡΕΘΕΙ από το osdmap.',
        error: 'Η τροποποίηση της σημαίας απορρίφθηκε',
        flag: {
          noout: 'Κανένας OSD δεν επισημαίνεται out από την κατανομή των δεδομένων — καμία επανεξισορρόπηση στην απώλεια δαίμονα',
          norebalance: 'Η επανεξισορρόπηση των δεδομένων είναι σε αναστολή',
          nobackfill: 'Το backfill είναι σε αναστολή',
          norecover: 'Το recovery είναι σε αναστολή',
          pause: 'ΟΛΟ το I/O των client είναι σε παύση (αναγνώσεις και εγγραφές)',
          noin: 'Οι OSD που εκκινούν δεν επισημαίνονται in αυτόματα',
          nodown: 'Οι μη προσβάσιμοι OSD δεν επισημαίνονται down — συγκαλύπτει πραγματικές αστοχίες'
        }
      },
      pools: {
        section: 'Pool',
        create: 'Δημιουργία pool',
        createGuard: 'Τα pool υπάρχουν μόνο σε αναπτυγμένη συστοιχία',
        notObserved: 'Καμία παρατήρηση των pool — η σάρωση του MON αναφέρει εδώ',
        empty: 'Κανένα pool στη συστοιχία',
        colName: 'Όνομα',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Εφαρμογή',
        colRule: 'Κανόνας CRUSH',
        colUsage: 'Χρήση',
        observedAtLabel: 'Παρατηρήθηκε στις',
        objects: '{n} αντικείμενα',
        inUseBy: 'σε χρήση από {name}',
        internalGuard: 'Εσωτερικό pool του Ceph — η πλατφόρμα δεν το διαγράφει ποτέ',
        delete: 'Διαγραφή pool',
        deleteGuard: 'Καταναλώνεται από τον χώρο αποθήκευσης {name} — διαγράψτε πρώτα τον χώρο αποθήκευσης',
        hint: 'Μόνο pool με αντιγραφή (το erasure coding είναι εκτός εμβέλειας για την v1). Η αντιγραφή ζει στο Ceph: αυτός ο πίνακας είναι η παρατηρούμενη αλήθεια από τη σάρωση του MON.',
        createTitle: 'Δημιουργία pool',
        createHint: 'Το pool γεννιέται στη συστοιχία με τη ζητούμενη αντιγραφή και την εφαρμογή rbd ενεργοποιημένη — τη δουλειά την κάνει μια εργασία σε έναν κόμβο MON. Ενεργοποιήστε την «Πρόταση ως χώρου αποθήκευσης» για να το καταναλώσετε αμέσως με την ίδια κίνηση.',
        name: 'Όνομα του pool',
        nameHint: 'DNS-safe (πεζά γράμματα, ψηφία, παύλες).',
        size: 'Αντίγραφα (size)',
        sizeHint: 'Αντίγραφα κάθε αντικειμένου. Προεπιλογή 3.',
        minSize: 'Ελάχιστα αντίγραφα (min_size)',
        minSizeHint: 'Ελάχιστα αντίγραφα για την εξυπηρέτηση I/O — ακολουθεί το size − 1 μέχρι να το τροποποιήσετε.',
        createError: 'Η δημιουργία του pool απορρίφθηκε',
        deleteTitle: 'Διαγραφή pool',
        deleteBody: 'Το pool {pool} και ΚΑΘΕ αντικείμενο μέσα του καταστρέφονται μη αναστρέψιμα. Πληκτρολογήστε το όνομα του pool για επιβεβαίωση.',
        confirmLabel: 'Όνομα του pool',
        confirmHint: 'Πληκτρολογήστε το όνομα του pool για επιβεβαίωση',
        deleteError: 'Η διαγραφή του pool απορρίφθηκε',
        detailTitle: 'Λεπτομέρειες pool',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Ενεργοποιημένος',
        autoscalerOff: 'Απενεργοποιημένος',
        autoscalerWarn: 'Ειδοποίηση',
        pgNumLabel: 'Αριθμός PG',
        pgNumCaption: 'Παρατηρούμενος: ο autoscaler μπορεί να τον αλλάξει αυτόνομα — αυτό το πεδίο γράφει μια επιθυμία.',
        storage: 'Συσχετισμένος χώρος αποθήκευσης TVirt',
        addAsStorage: 'Προσθήκη ως χώρου αποθήκευσης TVirt',
        ruleSudoHint: 'Η αλλαγή του κανόνα CRUSH απαιτεί τον κωδικό πρόσβασης του χειριστή.',
        updateError: 'Η τροποποίηση του pool απορρίφθηκε',
        updated: 'Η τροποποίηση του pool ξεκίνησε — η παρατήρηση ενημερώνεται μόνη της'
      },
      crush: {
        section: 'Κανόνες CRUSH',
        notObserved: 'Καμία παρατήρηση CRUSH ακόμη — η σάρωση του MON αναφέρει εδώ',
        empty: 'Κανένας κανόνας δεν παρατηρήθηκε στη συστοιχία',
        hint: 'Ένας κανόνας αποφασίζει ΠΟΥ καταλήγουν τα αντίγραφα κάθε αντικειμένου — ο τομέας αστοχίας του είναι η μονάδα που μπορεί να αστοχήσει χωρίς απώλεια δεδομένων. Τα pool δείχνουν σε έναν κανόνα· ο builtin replicated_rule (ένα αντίγραφο ανά διακομιστή) είναι η προεπιλογή γέννησης.',
        create: 'Δημιουργία κανόνα',
        createGuard: 'Οι κανόνες CRUSH υπάρχουν μόνο σε αναπτυγμένη συστοιχία',
        createTitle: 'Δημιουργία κανόνα CRUSH',
        createHint: 'Ένας κανόνας = μία επιλογή τομέα αστοχίας. Ο κανόνας γεννιέται με αντιγραφή στο προεπιλεγμένο root — τη δουλειά την κάνει μια εργασία σε έναν κόμβο MON· συσχετίστε τα pool από την καρτέλα Pool μετά.',
        createError: 'Η δημιουργία του κανόνα απορρίφθηκε',
        name: 'Όνομα του κανόνα',
        nameHint: 'DNS-safe (πεζά γράμματα, ψηφία, παύλες).',
        domain: 'Τομέας αστοχίας',
        domainChoice: {
          osd: 'Κάθε αντίγραφο σε διαφορετικό OSD',
          host: 'Κάθε αντίγραφο σε διαφορετικό διακομιστή',
          rack: 'Κάθε αντίγραφο σε διαφορετικό rack'
        },
        domainCustom: 'Προσαρμοσμένος (βήματα γραμμένα στο χέρι)',
        domainOther: 'Κάθε αντίγραφο σε διαφορετικό {type}',
        rackGuardHint: 'Κανένα bucket rack δεν υπάρχει στην παρατηρούμενη ιεραρχία: ο κανόνας μπορεί να δημιουργηθεί ούτως ή άλλως, αλλά κανένα pool δεν θα μπορεί να δείξει σε αυτόν μέχρι να δηλωθεί ένα rack στην τοποθέτηση των διακομιστών-μελών (ρυθμίσεις κόμβου) — η εργασία επανευθυγράμμισης χτίζει το bucket και η συσχέτιση ανοίγει μόνη της.',
        treeTitle: 'Παρατηρούμενη ιεραρχία',
        treeNotObserved: 'Καμία παρατήρηση της ιεραρχίας — η σάρωση του MON αναφέρει εδώ',
        treeOsds: '{n} OSD',
        treeHint: 'Ο χάρτης CRUSH όπως τον βλέπει η συστοιχία: root → δηλωμένα επίπεδα → διακομιστές (host) → OSD. Η τοπολογία ακολουθεί τη δηλωμένη τοποθέτηση κάθε διακομιστή (ρυθμίσεις κόμβου) — μια αλλαγή θέσης την επανευθυγραμμίζει μέσω εργασίας.',
        unplacedWarning: 'Μέλη χωρίς δηλωμένη θέση: {nodes} — τα host τους μένουν απευθείας κάτω από το root, έξω από τη δηλωμένη τοπολογία. Δηλώστε τη θέση στις ρυθμίσεις του κόμβου (μια προειδοποίηση, ποτέ μπλοκάρισμα).',
        colName: 'Όνομα',
        colDomain: 'Τομέας αστοχίας',
        colPools: 'Pool',
        builtinChip: 'builtin',
        builtinGuard: 'Ο προεπιλεγμένος κανόνας της συστοιχίας — η πλατφόρμα δεν τον διαγράφει ποτέ',
        detailAction: 'Λεπτομέρειες κανόνα',
        detailType: 'Τύπος',
        backToRules: 'Κανόνες',
        ruleNotObserved: 'Η παρατηρούμενη λίστα κανόνων δεν κατονομάζει αυτόν τον κανόνα',
        noPools: 'Κανένα pool δεν πατάει πάνω σε αυτόν τον κανόνα',
        delete: 'Διαγραφή κανόνα',
        deleteTitle: 'Διαγραφή κανόνα CRUSH',
        deleteBody: 'Ο κανόνας {rule} αφαιρείται από την crushmap της συστοιχίας. Κανένα pool δεν πρέπει να πατάει πάνω του. Πληκτρολογήστε το όνομα του κανόνα για επιβεβαίωση.',
        deleteGuard: 'Το pool {name} πατάει πάνω του — στρέψτε πρώτα το pool σε άλλον κανόνα',
        confirmLabel: 'Όνομα του κανόνα',
        confirmHint: 'Πληκτρολογήστε το όνομα του κανόνα για επιβεβαίωση',
        deleteError: 'Η διαγραφή του κανόνα απορρίφθηκε',
        changeRule: 'Αλλαγή κανόνα CRUSH',
        changeRuleTitle: 'Αλλαγή κανόνα CRUSH',
        changeRuleHint: 'Το pool αρχίζει να τοποθετεί τα αντικείμενά του σύμφωνα με τον επιλεγμένο κανόνα — το Ceph μετακινεί τα υπάρχοντα δεδομένα για να συμμορφωθεί (σε γεμάτο pool ακολουθεί επανεξισορρόπηση).',
        changeRuleError: 'Η αλλαγή κανόνα απορρίφθηκε',
        rule: 'Κανόνας CRUSH',
        rawTitle: 'Ακατέργαστη crushmap (απομεταγλωττισμένη)',
        rawWarning: 'ΚΙΝΔΥΝΟΣ: αυτό το κείμενο είναι ΟΛΟΚΛΗΡΗ η πολιτική τοποθέτησης της συστοιχίας. Ένας λάθος χάρτης μπορεί να σπάσει την τοποθέτηση όλων των pool μαζί. Η αποθήκευση μεταγλωττίζει και δοκιμάζει τον χάρτη με το crushtool ΠΡΙΝ τον εγχύσει — αλλά ένας έγκυρος χάρτης μπορεί και πάλι να είναι κακή ιδέα.',
        rawReload: 'Επαναφόρτωση',
        rawLoading: 'Ερώτημα σε πτήση — μια εργασία read-only απομεταγλωττίζει την crushmap…',
        rawSave: 'Αποθήκευση crushmap',
        rawSaveTitle: 'Έγχυση crushmap',
        rawSaveBody: 'Το επεξεργασμένο κείμενο αντικαθιστά την crushmap ΟΛΟΚΛΗΡΗΣ της συστοιχίας μετά από compile + test του crushtool. Πληκτρολογήστε το όνομα της συστοιχίας για επιβεβαίωση.',
        rawConfirmLabel: 'Όνομα της συστοιχίας',
        rawConfirmHint: 'Πληκτρολογήστε {name} για επιβεβαίωση',
        rawError: 'Η ενέργεια στην crushmap απέτυχε',
        rawHint: 'Το κείμενο είναι η μορφή crushtool -d. Σφάλματα μεταγλώττισης και αποτυχίες δοκιμών επιστρέφουν αυτολεξεί από το crushtool — ο χάρτης δεν φτάνει ποτέ στη συστοιχία αν αποτύχει μία από τις δύο πύλες.'
      },
      objects: {
        poolsSection: 'Εξερευνητής αντικειμένων',
        poolsHint: 'Επιλέξτε ένα pool για να απαριθμήσετε τις εικόνες RBD του. Κάθε βαθιά ανάγνωση τρέχει ως εργασία read-only σε έναν κόμβο MON — δεν μπλοκάρει (ούτε μπλοκάρεται από) τις πραγματικές λειτουργίες.',
        deployedGuard: 'Τα ερωτήματα αντικειμένων απαντούν μόνο σε αναπτυγμένη συστοιχία',
        browse: 'Περιήγηση στα αντικείμενα',
        detailAction: 'Λεπτομέρειες εικόνας',
        backToPools: 'Pool',
        backToImages: 'Εικόνες',
        refresh: 'Ανανέωση',
        loading: 'Ερώτημα σε πτήση — μια εργασία read-only ρωτά τη συστοιχία…',
        error: 'Το ερώτημα απέτυχε',
        retry: 'Νέα προσπάθεια',
        notRbd: 'Pool με application «{app}» — δεν περιέχει εικόνες RBD, τίποτα για εξερεύνηση εδώ',
        noImages: 'Καμία εικόνα RBD σε αυτό το pool',
        colImage: 'Εικόνα',
        colSize: 'Μέγεθος',
        colObjects: 'Αντικείμενα',
        colSnapshots: 'Στιγμιότυπα',
        imagesHint: 'Οι δίσκοι πάνω σε έναν χώρο αποθήκευσης rbd που καταναλώνει είναι εικόνες με όνομα το id του δίσκου τους. Η καταμέτρηση αντικειμένων είναι το provisioned (μέγεθος / μέγεθος αντικειμένου) — η πραγματική χρήση ζει στις λεπτομέρειες της εικόνας.',
        infoTitle: 'Εικόνα',
        infoSize: 'Εικονικό μέγεθος',
        infoObjects: 'Αντικείμενα (provisioned)',
        infoObjectSize: 'Μέγεθος αντικειμένου',
        infoPrefix: 'Πρόθεμα αντικειμένων',
        infoFormat: 'Μορφή',
        infoFeatures: 'Feature',
        usageTitle: 'Πραγματική χρήση (rbd du)',
        usageOf: 'από {provisioned} GiB provisioned',
        usageHint: 'Thin από τη φύση του: μόνο τα γραμμένα αντικείμενα καταλαμβάνουν byte.',
        watchersTitle: 'Watcher',
        noWatchers: 'Κανένας watcher — κανείς δεν έχει αυτή την εικόνα ανοιχτή αυτή τη στιγμή',
        snapshotsTitle: 'Στιγμιότυπα RBD',
        noSnapshots: 'Κανένα στιγμιότυπο RBD σε αυτή την εικόνα',
        colSnapshot: 'Στιγμιότυπο',
        colProtected: 'Προστατευμένο',
        colTimestamp: 'Δημιουργήθηκε',
        protected: 'προστατευμένο',
        mappingTitle: 'Φυσική αντιστοίχιση (σύνολο OSD)',
        mappingSampled: 'Δείγμα {sampled} αντικειμένων από {total} — μια ειλικρινής σύνοψη: για μεγάλες εικόνες το σύνολο συγκλίνει σε ΟΛΟΥΣ τους OSD του pool (το CRUSH κατανέμει τα αντικείμενα σε όλο το pool).',
        mappingComplete: 'Όλα τα αντικείμενα αντιστοιχίστηκαν ({total} από {total}).',
        objectQueryTitle: 'Αντιστοίχιση ενός μεμονωμένου αντικειμένου',
        objectName: 'Όνομα αντικειμένου',
        objectHint: 'Τα ονόματα αντικειμένων RADOS είναι <πρόθεμα>.<δείκτης 16-hex> — το ceph osd map απαντά με το PG και τις τριάδες OSD.',
        mapObject: 'Αντιστοίχιση',
        primary: 'πρωτεύων: osd.{osd}'
      },
      registerDevice: {
        title: 'Καταχώριση συσκευής OSD',
        hint: 'Σε ζωντανή συστοιχία η καταχώριση και ΠΡΟΕΤΟΙΜΑΖΕΙ τη συσκευή: γίνεται OSD BlueStore με μια αυτόματη εργασία συναφή με τον κόμβο (ποτέ κενή, επικυρωμένο 2026-07-24). Μια συσκευή ανήκει το πολύ σε μία συστοιχία Ceph σε όλο τον στόλο.',
        disk: 'Δίσκος δεδομένων',
        diskHint: 'Οι δηλωμένοι δίσκοι δεδομένων του κόμβου — όνομα και σειριακός αριθμός',
        noDeclared: 'Κανένας δίσκος δεδομένων δηλωμένος σε αυτόν τον κόμβο — επισημάνετέ τους πρώτα στις τοπικές ρυθμίσεις του κόμβου',
        serialHint: 'Ο σειριακός αριθμός της συσκευής — το pin ταυτότητας',
        encrypted: 'Κρυπτογράφηση αυτού του OSD (dmcrypt)',
        encryptedHint: 'Η επιλογή ανά OSD (η λειτουργία της συστοιχίας είναι «επιλογή ανά OSD»): παγώνει σε αυτόν τον δίσκο κατά την καταχώριση — μια μεταγενέστερη αλλαγή λειτουργίας δεν την ξαναγράφει ποτέ· το κάνει η ενέργεια γραμμής κρυπτογράφηση/αποκρυπτογράφηση.',
        error: 'Η καταχώριση απορρίφθηκε'
      },
      unregisterDevice: {
        title: 'Κατάργηση καταχώρισης συσκευής',
        body: 'Μόνο μητρώο: το {name} παύει να είναι υποψήφιος OSD αυτής της συστοιχίας. Τα byte του δεν θίγονται.',
        error: 'Η κατάργηση καταχώρισης απορρίφθηκε'
      },
      deploy: {
        action: 'Νέα προσπάθεια ανάπτυξης',
        title: 'Νέα προσπάθεια του bootstrap',
        body: 'Το bootstrap της γέννησης ξαναρχίζει από την τρέχουσα διαμόρφωση: οι MON εκκινούν, κάθε καταχωρισμένη συσκευή προετοιμάζεται και ενεργοποιείται ως OSD BlueStore. Η ενέργεια τρέχει ως μακροεργασία — η φάση ενημερώνεται μόνη της.',
        started: 'Το bootstrap ξεκίνησε — συνεχίζεται ως μακροεργασία· η φάση ενημερώνεται μόνη της',
        error: 'Το bootstrap απορρίφθηκε'
      },
      propose: {
        action: 'Πρόταση ως χώρου αποθήκευσης',
        title: 'Πρόταση ως χώρου αποθήκευσης',
        hintPool: 'Το υπάρχον pool {name} γίνεται χώρος αποθήκευσης TVirt: μια ταυτότητα cephx περιορισμένη στο pool καταλήγει στο keystore και ο χώρος αποθήκευσης ceph-rbd γεννιέται έτοιμος. Η πρόταση καταναλώνει το pool — δεν δημιουργεί ποτέ κανένα.',
        hintFs: 'Το υπάρχον σύστημα αρχείων {name} γίνεται χώρος αποθήκευσης TVirt: μια ταυτότητα cephx περιορισμένη στο σύστημα αρχείων καταλήγει στο keystore και ο χώρος αποθήκευσης cephfs γεννιέται έτοιμος και προσαρτημένος. Η πρόταση καταναλώνει το σύστημα αρχείων — δεν δημιουργεί ποτέ κανένα.',
        name: 'Όνομα του χώρου αποθήκευσης',
        nameHint: 'DNS-1123, μοναδικό στην εμβέλεια — η ταυτότητα cephx παίρνει το όνομά της από αυτόν.',
        path: 'Path μέσα στο σύστημα αρχείων',
        pathHint: 'Απόλυτο path μέσα στο σύστημα αρχείων που προσαρτά ο χώρος αποθήκευσης — / αν έχετε αμφιβολία.',
        alsoPropose: 'Άμεση πρόταση ως χώρου αποθήκευσης',
        alsoProposePoolHint: 'Μετά τη δημιουργία, η ίδια κίνηση προτείνει το νεογέννητο pool ως χώρο αποθήκευσης ceph-rbd — δύο ρητές κλήσεις, ένας μόνο διάλογος.',
        alsoProposeFsHint: 'Μετά τη δημιουργία, η ίδια κίνηση προτείνει το νεογέννητο σύστημα αρχείων ως χώρο αποθήκευσης cephfs — δύο ρητές κλήσεις, ένας μόνο διάλογος.',
        guard: 'Πρόταση ως χώρου αποθήκευσης — μόνο σε συστοιχία healthy',
        started: 'Η πρόταση έγινε δεκτή — ο χώρος αποθήκευσης υλοποιείται· θα τον βρείτε κάτω από την Αποθήκευση',
        submit: 'Δημιουργία χώρου αποθήκευσης',
        error: 'Η πρόταση απορρίφθηκε'
      },
      fs: {
        section: 'Συστήματα αρχείων',
        create: 'Δημιουργία συστήματος αρχείων',
        createGuard: 'Τα συστήματα αρχείων υπάρχουν μόνο σε αναπτυγμένη συστοιχία',
        mdsFirstGuard: 'Προσθέστε πρώτα έναν MDS — ένα σύστημα αρχείων χωρίς metadata server γεννιέται μη εξυπηρετήσιμο',
        notObserved: 'Καμία παρατήρηση των συστημάτων αρχείων — η σάρωση του MON αναφέρει εδώ',
        empty: 'Κανένα σύστημα αρχείων στη συστοιχία',
        colName: 'Όνομα',
        colPools: 'Pool',
        colMds: 'MDS',
        noActiveMds: 'κανένας active MDS',
        delete: 'Αφαίρεση συστήματος αρχείων',
        deleteGuard: 'Καταναλώνεται από τον χώρο αποθήκευσης {name} — διαγράψτε πρώτα τον χώρο αποθήκευσης',
        hint: 'Ένα σύστημα αρχείων κατέχει τα pool δεδομένων και metadata του (cephfs.<όνομα>.data / .meta): γεννιούνται μαζί του και πεθαίνουν μαζί του — removeFs, ποτέ σκέτη διαγραφή pool στο χέρι. Αυτός ο πίνακας είναι η παρατηρούμενη αλήθεια από τη σάρωση του MON.',
        createTitle: 'Δημιουργία συστήματος αρχείων',
        createHint: 'Το σύστημα αρχείων γεννιέται στη συστοιχία με τα δύο pool του (application cephfs) και εξυπηρετείται από τους δηλωμένους MDS — τη δουλειά την κάνει μια εργασία σε έναν κόμβο MON. Ενεργοποιήστε την «Πρόταση ως χώρου αποθήκευσης» για να το καταναλώσετε αμέσως με την ίδια κίνηση.',
        name: 'Όνομα του συστήματος αρχείων',
        nameHint: 'DNS-safe (πεζά γράμματα, ψηφία, παύλες).',
        sizeHint: 'Αντίγραφα ΚΑΙ ΤΩΝ ΔΥΟ νεογέννητων pool. Προεπιλογή 3.',
        createError: 'Η δημιουργία του συστήματος αρχείων απορρίφθηκε',
        deleteTitle: 'Αφαίρεση συστήματος αρχείων',
        deleteBody: 'Το σύστημα αρχείων {fs} και ΚΑΘΕ αρχείο μέσα του καταστρέφονται μη αναστρέψιμα — τα pool δεδομένων και metadata του πεθαίνουν μαζί του. Πληκτρολογήστε το όνομα του συστήματος αρχείων για επιβεβαίωση.',
        confirmLabel: 'Όνομα του συστήματος αρχείων',
        confirmHint: 'Πληκτρολογήστε το όνομα του συστήματος αρχείων για επιβεβαίωση',
        deleteError: 'Η αφαίρεση του συστήματος αρχείων απορρίφθηκε'
      },
      destroy: {
        action: 'Καταστροφή',
        retryAction: 'Νέα προσπάθεια καταστροφής',
        retryGuard: 'Η καταστροφή τρέχει — η νέα προσπάθεια ισχύει για μια αποτυχημένη καταστροφή (αλλιώς το lease την απορρίπτει)',
        title: 'Καταστροφή της συστοιχίας',
        body: 'Το αναπτυγμένο fabric αποξηλώνεται: κάθε δαίμονας αυτής της συστοιχίας σταματά, η κατάσταση συστήματός του και τα κλειδιά στο keystore απελευθερώνονται. Με την επιτυχία της καταστροφής η συστοιχία αφαιρείται αυτόματα.',
        confirmLabel: 'Όνομα της συστοιχίας',
        confirmHint: 'Πληκτρολογήστε το όνομα της συστοιχίας για επιβεβαίωση',
        wipe: 'Σβήσιμο των καταχωρισμένων συσκευών',
        wipeHint: 'Επιλεγμένο: οι υπογραφές κάθε καταχωρισμένης συσκευής σβήνονται — τα δεδομένα πάνω τους καταστρέφονται. Μη επιλεγμένο: τα byte μένουν ανέπαφα και οι συσκευές επιστρέφουν σε καταχωρισμένες.',
        guard: 'Καταστροφή — τίποτα αναπτυγμένο',
        started: 'Η καταστροφή ξεκίνησε — συνεχίζεται ως μακροεργασία· η φάση ενημερώνεται μόνη της',
        error: 'Η καταστροφή απορρίφθηκε'
      },
      delete: {
        guard: 'Διαγραφή — μόνο μια μη αναπτυγμένη διαμόρφωση (πρώτα καταστροφή)',
        title: 'Να διαγραφεί το {name};',
        body: 'Η διαμόρφωση και το μητρώο συσκευών της αφαιρούνται. Νόμιμο μόνο όσο τίποτα δεν είναι αναπτυγμένο.',
        error: 'Η διαγραφή απορρίφθηκε'
      }
    }
  }
}
